import { StyledHeaderCell } from './styles';

export default StyledHeaderCell;
